module.exports = "/assets/data/37450cd4b6e0081bad5451d61e9719a5-SM6.data.json";